import React, { createContext, useCallback, useContext, useMemo, useRef } from "react";

const AudioPlayerGroupContext = createContext(null);

export const AudioPlayerGroup = ({ children }) => {
  const activePlayerIdRef = useRef(null);
  const registryRef = useRef(new Map());

  const register = useCallback((playerId, pause) => {
    registryRef.current.set(playerId, pause);
  }, []);

  const unregister = useCallback((playerId) => {
    registryRef.current.delete(playerId);
    if (activePlayerIdRef.current === playerId) {
      activePlayerIdRef.current = null;
    }
  }, []);

  const requestPlay = useCallback(
    (playerId) => {
      for (const [id, pause] of registryRef.current.entries()) {
        if (id === playerId) continue;
        if (pause) pause();
      }
      activePlayerIdRef.current = playerId;
    },
    [],
  );

  const value = useMemo(
    () => ({
      register,
      unregister,
      requestPlay,
    }),
    [register, unregister, requestPlay],
  );

  return (
    <AudioPlayerGroupContext.Provider value={value}>
      {children}
    </AudioPlayerGroupContext.Provider>
  );
};

export const useAudioPlayerGroup = () => useContext(AudioPlayerGroupContext);
